import { shallow } from 'zustand/shallow'
import { createWithEqualityFn } from 'zustand/traditional'

type EggStoreType = {
  isSnowVisible: boolean
}

const useStore = createWithEqualityFn<EggStoreType>(() => ({ isSnowVisible: false }), shallow)

export const eggStore = {
  setIsSnowVisible: (isVisible: boolean): void => {
    useStore.setState({ isSnowVisible: isVisible })
  },

  useStore
}
